import * as React from "react";
import { FeedItemNewEntry } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementNewEntry = ({ item }: { item: FeedItemNewEntry }) => {
  const description = item.entry.description;

  return (
    <FeedElementContainer
      href={`/entry/${item.entry.id}`}
      avatars={[
        { username: "Anonymous Chip", avatar_url: "/img/anonymous-chip.png" },
      ]}
      icon={"new"}
      title={
        <>
          <RLink white to={"/entry/" + item.entry.id}>{item.entry.title}</RLink>
          <span className="text-slate-500 dark:text-slate-400"> submitted to </span>
          <RLink white to={"/compo/" + item.compo_id}>{item.compo_name}</RLink>.
        </>
      }
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
    >
      <FormattedText text={description} />
    </FeedElementContainer>
  );
};
